<form autocomplete="off" [formGroup]="termsForm">
    <div class="row">
        <div class="col-md-12">
            <div class="mb-2">
                <ckeditor id="terms" [editor]="Editor" [config]="editorConfig" formControlName="txtTerms" (keydown.enter)="$event.stopPropagation()"></ckeditor>
            </div>
        </div>
    </div>
</form>